function initLazyLoadSliderVideos( )
{
    var desktopVideos = document.querySelectorAll( "video.video-lazy.desktop-only" );
    var mobileVideos = document.querySelectorAll( "video.video-lazy.mobile-only" );

    if( window.screen.width > 767 )
    {
        var videos = desktopVideos;
    }
    else
    {
        var videos = mobileVideos;
    }
    for( var i = 0; i < videos.length; i++ )
    {
        var source = videos[ i ].querySelector( "source" );
        if( source.getAttribute( "data-src" ) )
        {
            source.setAttribute( "src", source.getAttribute("data-src") );
            videos[ i ].closest( ".arne-slider-wrapper" ).classList.remove( "hidden" );
            videos[ i ].load( );
        }
        else
        {
            videos[ i ].closest( ".arne-slider-wrapper" ).classList.add( "hidden" );
        }
    }
}

initLazyLoadSliderVideos( );

window.addEventListener( "resize", initLazyLoadSliderVideos );